import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useHistory, Link} from 'react-router-dom';

import Wrapper from 'components/structure/Wrapper';
import ModalAddUpdateSession from 'components/Session/ModalAddUpdateSession';
import useSession from 'hooks/useSession';
import Table from 'components/Table/Table';
import Pages from 'configs/pages';
import ParserRestApi from 'helpers/ParserRestApi';
import Urls from 'configs/urls';

function Sessions() {
	const {t} = useTranslation();
	const history = useHistory();
	const [form, setForm] = useState({
		open: false,
		id: false
	});

	const [detailOpenId, setDetailOpenId] = useState(false);


	const goSession = (id) => {
		history.push(Pages.plannerWithSession.getUrl(id));
	}

	const toogleForm = (id = false) => {
		setForm({
			id,
			open: !form.open
		});
	}

	const setOpenForm = (val) => {
		setForm({
			id: form.id,
			open: val
		});
	}

	const {
		launchMethod,
		session
	} = useSession();

	const getId = (item) => {
		let id = false;
		if (typeof item['@id'] !== 'undefined') {
			id = ParserRestApi.parseId(item['@id']);
		}
		if (typeof item.id !== 'undefined') {
			id = item.id;
		}
		return id;
	}

	return (
		<Wrapper
			className="Sessions"
			displayFooter={false}
			title={{
				title: t('Sessions.title'),
				action: {
					icon: (
						<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2"
						     fill="none" strokeLinecap="round" strokeLinejoin="round">
							<line x1="12" y1="5" x2="12" y2="19"></line>
							<line x1="5" y1="12" x2="19" y2="12"></line>
						</svg>
					),
					label: t('Sessions.createSession'),
					onClick: () => {
						toogleForm(false);
					}
				}
			}}
		>
			<ModalAddUpdateSession
				id={form.id}
				forceOpen={form.open}
				setForceOpenOpen={setOpenForm}
			/>
			<Table
				componants={{
					error: (
						<a href={Urls.baseLogin.replace(':sessionId', session !== false ? session : '')}>
							{t('Sessions.table.login')}
						</a>
					),
					footerItem: (item) => {
						if (detailOpenId !== item.id) {
							return (null);
						}
						if (item.groupes) {
							return (
								<tr>
									<td colSpan="4">
										{item.groupes.map((group) => {
											let total = 0;
											group.detail.map((detail) => {
												total += detail.count;
											});

											return (

												<div className="card mb-2 group-info">
													<div className="row g-0 sh-12">
														<div className="col-auto">
															<img
																src={Urls.baseGroupImage + item.id + '/' + group.id + '/1'}
																alt="alternate text"
																className="card-img card-img-horizontal sw-13 sw-lg-15"
															/>
														</div>
														<div className="col">
															<div className="card-body pt-0 pb-0 h-100">
																<div className="row g-0 h-100 align-content-center">
																	<div
																		className="col-9 d-flex flex-column mb-2 mb-md-0">
																		<p>{group.name}</p>
																		<div
																			className="text-small text-muted text-truncate">
																			{total} {t('Sessions.dominos')}
																		</div>
																		<ul>
																			{group.detail.map((detail) => {
																				return (
																					<li>
																						<div
																							className="color-render"
																							style={{
																								backgroundColor: detail.color.code
																							}}></div>
																						{detail.count}
																					</li>
																				);
																			})}
																		</ul>
																	</div>
																	<div
																		className="col-3 d-flex align-items-center justify-content-md-end">

																		<Link
																			to={Pages.toolBuildGroup.getUrl(item.id, group.id)}>
																			<svg viewBox="0 0 24 24" width="24"
																			     height="24"
																			     stroke="currentColor" strokeWidth="2"
																			     fill="none" strokeLinecap="round"
																			     strokeLinejoin="round"
																			>
																				<path
																					d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
																			</svg>
																		</Link>

																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											)
												;
										})}
									</td>
								</tr>
							)
						}

						return (null);
					}
				}}
				hook={useSession}
				columns={[
					{
						label: t('Sessions.table.name'),
						key: 'name'
					},
					{
						label: t('Sessions.table.createdAt'),
						key: 'createdAt',
						type: 'date'
					},
					{
						label: t('Sessions.table.updatedAt'),
						key: 'updatedAt',
						type: 'date'
					}
				]}
				actions={[
					{
						label: (
							<svg viewBox="0 0 24 24" width="24" height="24"
							     stroke="currentColor"
							     strokeWidth="2" fill="none" strokeLinecap="round"
							     strokeLinejoin="round"
							>
								<circle cx="12" cy="12" r="10"></circle>
								<polygon points="10 8 16 12 10 16 10 8"></polygon>
							</svg>
						),
						key: 'change-session',
						onClick: (item) => {
							let id = getId(item);
							if (id !== false) {
								goSession(id);
							}
						}
					},
					{
						label: (
							<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2"
							     fill="none" strokeLinecap="round" strokeLinejoin="round">
								<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
								<path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
							</svg>
						),
						key: 'edit-session',
						onClick: (item) => {
							let id = getId(item);
							if (id !== false) {
								toogleForm(item.id);
							}
						}
					},
					{
						label: (
							<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2"
							     fill="none"
							     strokeLinecap="round" strokeLinejoin="round">
								<polyline points="3 6 5 6 21 6"></polyline>
								<path
									d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
								<line x1="10" y1="11" x2="10" y2="17"></line>
								<line x1="14" y1="11" x2="14" y2="17"></line>
							</svg>
						),
						key: 'delete-session',
						onClick: (item) => {
							let id = getId(item);
							if (id !== false) {
								launchMethod('deleteItem', [id]);
							}
						}
					},
					{
						getLabel: (item) => {
							return (
								<a href={Urls.baseExport.replace(':sessionId', item.id)}>
									<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor"
									     strokeWidth="2" fill="none"
									     strokeLinecap="round" strokeLinejoin="round" className="css-i6dzq1">
										<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
										<polyline points="7 10 12 15 17 10"></polyline>
										<line x1="12" y1="15" x2="12" y2="3"></line>
									</svg>
								</a>
							);
						},
						key: 'export-session'
					},
					{
						getLabel: (item) => {
							if (detailOpenId !== item.id) {
								return (
									<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor"
									     strokeWidth="2" fill="none" strokeLinecap="round"
									     strokeLinejoin="round"
									>
										<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
										<circle cx="12" cy="12" r="3"></circle>
									</svg>
								);
							}
							return (
								<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2"
								     fill="none" strokeLinecap="round" strokeLinejoin="round"
								>
									<path
										d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
									<line x1="1" y1="1" x2="23" y2="23"></line>
								</svg>
							);
						},
						key: 'view-detail-session',
						onClick: (item) => {
							let id = getId(item);
							if (detailOpenId === id) {
								id = false;
							}
							setDetailOpenId(id);
						}
					}
				]}
			/>

		</Wrapper>
	);
}

export default Sessions;
